import kairosPartnerLogo from "@/assets/kairos-partner-logo.png";

const StrategicPartner = () => {
  return (
    <section className="py-16 md:py-20 bg-muted/30">
      <div className="container px-6">
        <div className="max-w-3xl mx-auto text-center mb-8">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            Strategic Partner
          </h2>
        </div>
        <div className="flex flex-col items-center gap-3">
          <img
            src={kairosPartnerLogo}
            alt="Kairos Strategic Partner"
            className="h-20 md:h-24 w-auto object-contain"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-6 h-6"
            aria-label="Switzerland"
          >
            <rect fill="#DA291C" width="32" height="32" rx="2" />
            <path fill="#FFFFFF" d="M13 6h6v8h8v6h-8v8h-6v-8H5v-6h8z" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default StrategicPartner;
